var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-workgroup"},[_c('div',{staticClass:"card-workgroup__inner"},[_c('router-link',{attrs:{"to":_vm.content.route},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.content.text))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }